import { useAuth } from "../../../store/useAuthStore";
import { useLoginStore } from "../../../store/useLoginStore";
import { getQueryClient } from "../../../config/queryClient.config";
import Button from "../../ui/button";
import { cn } from "../../../utils/cn.utils";
// import { useModalStore } from "../../../store/useModalStore";
// import { MODAL_KEY } from "../../../lib/constants/modal.constants";
// import AccountGuideBubble from "../../ui/bubble";

export default function Header() {
  const auth = useAuth();
  const clearAuth = useAuth((state) => state.clearAuth);
  // const { openModal } = useModalStore();
  const { access, setAccess } = useLoginStore();

  const isActive = auth.activeStoreNum > 0
  const label = isActive ? `활성 지점 ${auth.activeStoreNum}개` : "월 결제 후 서비스 이용가능합니다."

  // const location = useLocation();

  return (
    <header className={cn("w-full h-[64px] flex-row-between px-[20px]", isActive ? "bg-primary-05" : "bg-gray-02")}>
      <div className="flex-row">
        <p className={cn("text-[16px] font-semibold", isActive ? "text-[#1976D2]" : "text-gray-40")} >{label}</p>
        {/* <Button
          className="px-4 py-[6px] ml-4"
          variant="primary"
          label=" "
          onClick={() => openModal(MODAL_KEY.PaymentDetail, { pathname: location.pathname })}
        >
          <div className="flex-row space-x-2">
            <span>결제하기</span>
            <img src="/static/icons/icon_arrow_right.svg" />
          </div>
        </Button>
        <p className="text-[13px] text-[#1976D2] p-1 ml-2">결제 내역</p>
        <AccountGuideBubble /> */}
      </div>
      <div className="flex-row gap-4">
        <p className="text-[16px]">{auth.username}님 환영합니다.</p>
        <Button
          label="로그아웃"
          className="border border-black text-style-compact-03"
          variant="ghost"
          onClick={() => {
            clearAuth();
            setAccess({ ...access, refreshToken: "", accessToken: "" });
            getQueryClient().clear();
            window.location.href = "/login";
          }}
        />
      </div>
    </header>
  );
};
